export const DISPLAY_TIMING_CONDITION = {
  INCLUDE: 'include',
  EXCLUDE: 'exclude',
} as const;

export const DISPLAY_TIMING_TYPE = {
  NONE: 'none',
  LUNCH: 'lunch',
  RANGE: 'range',
} as const;

export const MENU_DISPLAY_CONDITION = {
  NO_CONTROL: '0',
  TIME_CONTROL: '1',
  DISPLAY_GROUP_CONTROL: '2',
} as const;

export const TIMING_OVERLAY_FLAG = {
  HIDE_MENU: '0',
  SHOW_OVERLAY: '1',
} as const;

export const MENU_TIMING_STATUS = {
  AVAILABLE: 'available',
  HIDDEN: 'hidden',
  OVERLAY: 'overlay',
} as const;

export type DisplayTimingCondition = typeof DISPLAY_TIMING_CONDITION[keyof typeof DISPLAY_TIMING_CONDITION];

export type DisplayTimingType = typeof DISPLAY_TIMING_TYPE[keyof typeof DISPLAY_TIMING_TYPE];

export type MenuDisplayCondition = typeof MENU_DISPLAY_CONDITION[keyof typeof MENU_DISPLAY_CONDITION];

export type TimingOverlayFlag = typeof TIMING_OVERLAY_FLAG[keyof typeof TIMING_OVERLAY_FLAG];

export type MenuTimingStatus = typeof MENU_TIMING_STATUS[keyof typeof MENU_TIMING_STATUS];
